export default {
  title: 'LogicalStructure',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      format: 'string',
      title: 'Nazwa węzła',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Podaj nazwę węzła'
      }
    }
  }
};
